<template>
  <div>
    <v-geojson-layer :geojson="geojsonData.geojson" :options="geojsonOptions" ref="geolayer"></v-geojson-layer>
    <slot :currentItem="currentItem" :unit="value.metric" :min="min" :max="max"></slot>
    <tooltip :visible="ttvisible" :top="tttop" :left="ttleft" :title="tttitle" :value="ttvalue"></tooltip>
  </div>
</template>
<script>
import L from 'leaflet'
import Vue2Leaflet from 'vue2-leaflet'
import { getMin, getMax, validNumber, calcTooltipPosition } from '../util'
import ToolTip from './Tooltip'
import constants from '../constants'

function mouseover ({ target }) {
  target.setStyle({
    weight: 3,
    color: '#666',
    dashArray: ''
  })

  if (!L.Browser.ie && !L.Browser.opera) {
    target.bringToFront()
  }
}

function mousemove (d) {
  let geojsonItem = d.sourceTarget.feature.properties
  let item = this.geojsonData.data.find(
    x => x[this.idKey] === geojsonItem[this.geojsonIdKey]
  )

  let map = document.getElementById('map')
  let mouseX = d.containerPoint.x
  let mouseY = d.containerPoint.y

  let tt = calcTooltipPosition({x: mouseX, y: mouseY}, map.getBoundingClientRect(), 15, 15)
  this.ttleft = tt.x
  this.tttop = tt.y
  this.tttitle = geojsonItem.NUTS_NAME
  this.ttvalue = item.value
  this.ttvisible = true
}

function mouseout ({ target }) {
  target.setStyle({
    weight: 2,
    color: '#FFF',
    dashArray: ''
  })
  this.currentItem = { name: '', value: 0 }
  this.ttvisible = false
}

function mouseclick ({ target }) {
  this.$emit('click:item', { firstDimCode: target.feature.properties.NUTS_ID })
}

export default {
  props: [
    'geojson',
    'data',
    'center',
    'colorScale',
    'titleKey',
    'idKey',
    'value',
    'extraValues',
    'geojsonIdKey',
    'mapStyle',
    'zoom',
    'mapOptions',
    'gradients'
  ],
  mounted () {
    if (this.$parent._isMounted) {
      this.deferredMountedTo(this.$parent.mapObject)
      this.updateGradients()
    }
  },
  data () {
    return {
      calcTooltipPosition: calcTooltipPosition,
      ttvisible: false,
      tttop: null,
      ttleft: null,
      tttitle: null,
      ttsubtitle: null,
      ttvalue: null,
      currentItem: { name: '', value: 0 },
      geojsonOptions: {
        // adapted to show only polygons where data exist for
        filter: feature => {
          let itemGeoJSONID = feature.properties[this.geojsonIdKey]
          const {data} = this.geojsonData

          return data.find(x => x[this.idKey] === itemGeoJSONID)
        },
        style: feature => {
          let itemGeoJSONID = feature.properties[this.geojsonIdKey]
          const {data} = this.geojsonData
          let item = data.find(x => x[this.idKey] === itemGeoJSONID)
          if (!item) {
            return {
              color: 'white',
              weight: 2
            }
          }

          let valueParam = item[this.value.key] != null
            ? Number(item[this.value.key])
            : constants.UNAVAIL

          if (!validNumber(valueParam)) {
            let missingValueColor = constants.UNAVAIL_COLOUR
            return {
              color: 'white',
              fillColor: missingValueColor,
              weight: 2
            }
          }

          return {
            weight: 2,
            opacity: 1,
            color: 'white',
            fillOpacity: 0.7,
            fillColor: this.colorScale[this.gradients.getRangeNum(valueParam)]
          }
        },
        onEachFeature: (feature, layer) => {
          layer.on({
            mouseover: mouseover.bind(this),
            mousemove: mousemove.bind(this),
            mouseout: mouseout.bind(this),
            click: mouseclick.bind(this)
          })
        }
      }
    }
  },
  computed: {
    min () {
      return getMin(this.geojsonData.data, this.value.key)
    },
    max () {
      return getMax(this.geojsonData.data, this.value.key)
    },
    geojsonData () {
      return {geojson: {...this.geojson}, data: this.data}
    }
  },
  components: {
    'v-geojson-layer': Vue2Leaflet.GeoJSON,
    'tooltip': ToolTip
  },
  methods: {
    deferredMountedTo (parent) {
      this.parent = parent
      for (var i = 0; i < this.$children.length; i++) {
        if (typeof this.$children[i].deferredMountedTo === 'function') {
          this.$children[i].deferredMountedTo(parent)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ChoroplethLayer.vue